// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 24qDGfvb2rMn6oy8PVF95d
// Component: JEN29JpsqO

import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import ShinyButton from "../../ShinyButton"; // plasmic-import: JAvTJroKuQ/component
import EditIconRed from "../../EditIconRed"; // plasmic-import: tR7r1hOarV/component
import EditIconBlue from "../../EditIconBlue"; // plasmic-import: sn9j5yjs1h/component
import EditIcon from "../../EditIcon"; // plasmic-import: qgkS2GV7Eb/component
import SmallOverlayMenu from "../../SmallOverlayMenu"; // plasmic-import: 6okmavSCY4v/component

import { ThemeValue, useTheme } from "./PlasmicGlobalVariant__Theme"; // plasmic-import: 40N_XXvhaC/globalVariant

import "@plasmicapp/react-web/lib/plasmic.css";

import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import plasmic_plasmic_rich_components_css from "../plasmic_rich_components/plasmic_plasmic_rich_components.module.css"; // plasmic-import: jkU633o1Cz7HrJdwdxhVHk/projectcss
import plasmic_pro_pro_css from "../pro_pro/plasmic_pro_pro.module.css"; // plasmic-import: qtWvXH8Uhh67sc1TY2MZeK/projectcss
import projectcss from "./plasmic_hub_hub.module.css"; // plasmic-import: 24qDGfvb2rMn6oy8PVF95d/projectcss
import sty from "./PlasmicHeaderMenu.module.css"; // plasmic-import: JEN29JpsqO/css

import ClosesvgIcon from "./icons/PlasmicIcon__Closesvg"; // plasmic-import: ze_MFlDSdi/icon

createPlasmicElementProxy;

export type PlasmicHeaderMenu__VariantMembers = {
  view: "seeAllView" | "sectionView" | "publicSectionView" | "welcomeView";
  hideSignUpButton: "hideSignUpButton";
  red: "red";
  editMode: "editMode";
};
export type PlasmicHeaderMenu__VariantsArgs = {
  view?: SingleChoiceArg<
    "seeAllView" | "sectionView" | "publicSectionView" | "welcomeView"
  >;
  hideSignUpButton?: SingleBooleanChoiceArg<"hideSignUpButton">;
  red?: SingleBooleanChoiceArg<"red">;
  editMode?: SingleBooleanChoiceArg<"editMode">;
};
type VariantPropType = keyof PlasmicHeaderMenu__VariantsArgs;
export const PlasmicHeaderMenu__VariantProps = new Array<VariantPropType>(
  "view",
  "hideSignUpButton",
  "red",
  "editMode"
);

export type PlasmicHeaderMenu__ArgsType = {
  lgswitch?: React.ReactNode;
};
type ArgPropType = keyof PlasmicHeaderMenu__ArgsType;
export const PlasmicHeaderMenu__ArgProps = new Array<ArgPropType>("lgswitch");

export type PlasmicHeaderMenu__OverridesType = {
  root?: p.Flex<"div">;
  headerMenu?: p.Flex<"div">;
  signUpButton?: p.Flex<"div">;
  shinyButton?: p.Flex<typeof ShinyButton>;
  buttonDefault?: p.Flex<"div">;
  text?: p.Flex<"div">;
  freeBox?: p.Flex<"div">;
  editButton?: p.Flex<"button">;
  editIconRed?: p.Flex<typeof EditIconRed>;
  editIconBlue?: p.Flex<typeof EditIconBlue>;
  editIcon?: p.Flex<typeof EditIcon>;
  svg?: p.Flex<"svg">;
  smallOverlayMenu?: p.Flex<typeof SmallOverlayMenu>;
};

export interface DefaultHeaderMenuProps {
  lgswitch?: React.ReactNode;
  view?: SingleChoiceArg<
    "seeAllView" | "sectionView" | "publicSectionView" | "welcomeView"
  >;
  hideSignUpButton?: SingleBooleanChoiceArg<"hideSignUpButton">;
  red?: SingleBooleanChoiceArg<"red">;
  editMode?: SingleBooleanChoiceArg<"editMode">;
  className?: string;
}

const $$ = {};

function PlasmicHeaderMenu__RenderFunc(props: {
  variants: PlasmicHeaderMenu__VariantsArgs;
  args: PlasmicHeaderMenu__ArgsType;
  overrides: PlasmicHeaderMenu__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);

  const $props = {
    ...args,
    ...variants
  };

  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const currentUser = p.useCurrentUser?.() || {};

  const stateSpecs: Parameters<typeof p.useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "view",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.view
      },
      {
        path: "hideSignUpButton",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) =>
          $props.hideSignUpButton
      },
      {
        path: "red",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.red
      },
      {
        path: "editMode",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.editMode
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = p.useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });

  const globalVariants = ensureGlobalVariants({
    theme: useTheme()
  });

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        plasmic_plasmic_rich_components_css.plasmic_tokens,
        plasmic_pro_pro_css.plasmic_tokens,
        sty.root
      )}
    >
      <p.Stack
        as={"div"}
        data-plasmic-name={"headerMenu"}
        data-plasmic-override={overrides.headerMenu}
        hasGap={true}
        className={classNames(projectcss.all, sty.headerMenu, {
          [sty.headerMenueditMode]: hasVariant($state, "editMode", "editMode"),
          [sty.headerMenuglobal_theme_dark]: hasVariant(
            globalVariants,
            "theme",
            "dark"
          ),
          [sty.headerMenuhideSignUpButton]: hasVariant(
            $state,
            "hideSignUpButton",
            "hideSignUpButton"
          ),
          [sty.headerMenuview_publicSectionView]: hasVariant(
            $state,
            "view",
            "publicSectionView"
          ),
          [sty.headerMenuview_sectionView]: hasVariant(
            $state,
            "view",
            "sectionView"
          ),
          [sty.headerMenuview_seeAllView]: hasVariant(
            $state,
            "view",
            "seeAllView"
          ),
          [sty.headerMenuview_welcomeView]: hasVariant(
            $state,
            "view",
            "welcomeView"
          )
        })}
      >
        {(
          hasVariant($state, "hideSignUpButton", "hideSignUpButton")
            ? false
            : hasVariant($state, "view", "welcomeView")
            ? true
            : hasVariant(globalVariants, "theme", "dark")
            ? true
            : true
        ) ? (
          <div
            data-plasmic-name={"signUpButton"}
            data-plasmic-override={overrides.signUpButton}
            className={classNames(projectcss.all, sty.signUpButton, {
              [sty.signUpButtonglobal_theme_dark]: hasVariant(
                globalVariants,
                "theme",
                "dark"
              ),
              [sty.signUpButtonglobal_theme_light]: hasVariant(
                globalVariants,
                "theme",
                "light"
              ),
              [sty.signUpButtonhideSignUpButton]: hasVariant(
                $state,
                "hideSignUpButton",
                "hideSignUpButton"
              ),
              [sty.signUpButtonview_seeAllView]: hasVariant(
                $state,
                "view",
                "seeAllView"
              ),
              [sty.signUpButtonview_welcomeView]: hasVariant(
                $state,
                "view",
                "welcomeView"
              )
            })}
          >
            {(
              hasVariant($state, "editMode", "editMode")
                ? false
                : hasVariant($state, "view", "publicSectionView")
                ? false
                : hasVariant(globalVariants, "theme", "light")
                ? true
                : hasVariant(globalVariants, "theme", "dark")
                ? true
                : true
            ) ? (
              <ShinyButton
                data-plasmic-name={"shinyButton"}
                data-plasmic-override={overrides.shinyButton}
                className={classNames("__wab_instance", sty.shinyButton, {
                  [sty.shinyButtoneditMode]: hasVariant(
                    $state,
                    "editMode",
                    "editMode"
                  ),
                  [sty.shinyButtonglobal_theme_dark]: hasVariant(
                    globalVariants,
                    "theme",
                    "dark"
                  ),
                  [sty.shinyButtonglobal_theme_light]: hasVariant(
                    globalVariants,
                    "theme",
                    "light"
                  ),
                  [sty.shinyButtonview_publicSectionView]: hasVariant(
                    $state,
                    "view",
                    "publicSectionView"
                  ),
                  [sty.shinyButtonview_seeAllView]: hasVariant(
                    $state,
                    "view",
                    "seeAllView"
                  ),
                  [sty.shinyButtonview_welcomeView]: hasVariant(
                    $state,
                    "view",
                    "welcomeView"
                  )
                })}
              />
            ) : null}
            {(
              hasVariant(globalVariants, "theme", "light")
                ? true
                : hasVariant(globalVariants, "theme", "dark")
                ? false
                : false
            ) ? (
              <p.Stack
                as={"div"}
                data-plasmic-name={"buttonDefault"}
                data-plasmic-override={overrides.buttonDefault}
                hasGap={true}
                className={classNames(projectcss.all, sty.buttonDefault, {
                  [sty.buttonDefaultglobal_theme_dark]: hasVariant(
                    globalVariants,
                    "theme",
                    "dark"
                  ),
                  [sty.buttonDefaultglobal_theme_light]: hasVariant(
                    globalVariants,
                    "theme",
                    "light"
                  ),
                  [sty.buttonDefaulthideSignUpButton]: hasVariant(
                    $state,
                    "hideSignUpButton",
                    "hideSignUpButton"
                  ),
                  [sty.buttonDefaultview_seeAllView]: hasVariant(
                    $state,
                    "view",
                    "seeAllView"
                  )
                })}
              >
                <div
                  data-plasmic-name={"text"}
                  data-plasmic-override={overrides.text}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text,
                    {
                      [sty.texthideSignUpButton]: hasVariant(
                        $state,
                        "hideSignUpButton",
                        "hideSignUpButton"
                      ),
                      [sty.textview_seeAllView]: hasVariant(
                        $state,
                        "view",
                        "seeAllView"
                      )
                    }
                  )}
                >
                  {"Sign Up"}
                </div>
              </p.Stack>
            ) : null}
          </div>
        ) : null}
        <div
          data-plasmic-name={"freeBox"}
          data-plasmic-override={overrides.freeBox}
          className={classNames(projectcss.all, sty.freeBox, {
            [sty.freeBoxview_seeAllView]: hasVariant(
              $state,
              "view",
              "seeAllView"
            )
          })}
        >
          {p.renderPlasmicSlot({
            defaultContents: null,
            value: args.lgswitch
          })}
        </div>
        <button
          data-plasmic-name={"editButton"}
          data-plasmic-override={overrides.editButton}
          className={classNames(
            projectcss.all,
            projectcss.button,
            sty.editButton,
            {
              [sty.editButtoneditMode]: hasVariant(
                $state,
                "editMode",
                "editMode"
              ),
              [sty.editButtonglobal_theme_dark]: hasVariant(
                globalVariants,
                "theme",
                "dark"
              ),
              [sty.editButtonhideSignUpButton]: hasVariant(
                $state,
                "hideSignUpButton",
                "hideSignUpButton"
              ),
              [sty.editButtonred]: hasVariant($state, "red", "red"),
              [sty.editButtonview_publicSectionView]: hasVariant(
                $state,
                "view",
                "publicSectionView"
              ),
              [sty.editButtonview_sectionView]: hasVariant(
                $state,
                "view",
                "sectionView"
              ),
              [sty.editButtonview_seeAllView]: hasVariant(
                $state,
                "view",
                "seeAllView"
              ),
              [sty.editButtonview_welcomeView]: hasVariant(
                $state,
                "view",
                "welcomeView"
              )
            }
          )}
          ref={ref => {
            $refs["editButton"] = ref;
          }}
        >
          {(
            hasVariant($state, "red", "red")
              ? false
              : hasVariant($state, "view", "seeAllView")
              ? true
              : true
          ) ? (
            <EditIconRed
              data-plasmic-name={"editIconRed"}
              data-plasmic-override={overrides.editIconRed}
              className={classNames("__wab_instance", sty.editIconRed, {
                [sty.editIconRedglobal_theme_dark]: hasVariant(
                  globalVariants,
                  "theme",
                  "dark"
                ),
                [sty.editIconRedred]: hasVariant($state, "red", "red"),
                [sty.editIconRedview_seeAllView]: hasVariant(
                  $state,
                  "view",
                  "seeAllView"
                )
              })}
              rotated={
                hasVariant($state, "view", "seeAllView") ? true : undefined
              }
            />
          ) : null}
          {(
            hasVariant($state, "red", "red")
              ? false
              : hasVariant($state, "view", "seeAllView")
              ? true
              : true
          ) ? (
            <EditIconBlue
              data-plasmic-name={"editIconBlue"}
              data-plasmic-override={overrides.editIconBlue}
              className={classNames("__wab_instance", sty.editIconBlue, {
                [sty.editIconBlueglobal_theme_dark]: hasVariant(
                  globalVariants,
                  "theme",
                  "dark"
                ),
                [sty.editIconBluehideSignUpButton]: hasVariant(
                  $state,
                  "hideSignUpButton",
                  "hideSignUpButton"
                ),
                [sty.editIconBluered]: hasVariant($state, "red", "red"),
                [sty.editIconBlueview_publicSectionView]: hasVariant(
                  $state,
                  "view",
                  "publicSectionView"
                ),
                [sty.editIconBlueview_seeAllView]: hasVariant(
                  $state,
                  "view",
                  "seeAllView"
                )
              })}
              rotated={
                hasVariant($state, "view", "seeAllView") ? true : undefined
              }
            />
          ) : null}
          <EditIcon
            data-plasmic-name={"editIcon"}
            data-plasmic-override={overrides.editIcon}
            className={classNames("__wab_instance", sty.editIcon, {
              [sty.editIconeditMode]: hasVariant(
                $state,
                "editMode",
                "editMode"
              ),
              [sty.editIconglobal_theme_light]: hasVariant(
                globalVariants,
                "theme",
                "light"
              ),
              [sty.editIconred]: hasVariant($state, "red", "red"),
              [sty.editIconview_publicSectionView]: hasVariant(
                $state,
                "view",
                "publicSectionView"
              ),
              [sty.editIconview_seeAllView]: hasVariant(
                $state,
                "view",
                "seeAllView"
              )
            })}
            color={hasVariant($state, "red", "red") ? "red" : undefined}
            vertical={true}
          />

          <ClosesvgIcon
            data-plasmic-name={"svg"}
            data-plasmic-override={overrides.svg}
            className={classNames(projectcss.all, sty.svg, {
              [sty.svgeditMode]: hasVariant($state, "editMode", "editMode")
            })}
            role={"img"}
          />
        </button>
        {(
          hasVariant($state, "editMode", "editMode")
            ? true
            : hasVariant($state, "view", "welcomeView")
            ? true
            : hasVariant($state, "view", "publicSectionView")
            ? false
            : hasVariant($state, "view", "seeAllView")
            ? true
            : true
        ) ? (
          <SmallOverlayMenu
            data-plasmic-name={"smallOverlayMenu"}
            data-plasmic-override={overrides.smallOverlayMenu}
            className={classNames("__wab_instance", sty.smallOverlayMenu, {
              [sty.smallOverlayMenueditMode]: hasVariant(
                $state,
                "editMode",
                "editMode"
              ),
              [sty.smallOverlayMenured]: hasVariant($state, "red", "red"),
              [sty.smallOverlayMenuview_publicSectionView]: hasVariant(
                $state,
                "view",
                "publicSectionView"
              ),
              [sty.smallOverlayMenuview_seeAllView]: hasVariant(
                $state,
                "view",
                "seeAllView"
              ),
              [sty.smallOverlayMenuview_welcomeView]: hasVariant(
                $state,
                "view",
                "welcomeView"
              )
            })}
            color={
              hasVariant($state, "editMode", "editMode") ? "dark" : undefined
            }
            inactive={
              hasVariant($state, "editMode", "editMode") ? true : undefined
            }
            view={
              hasVariant($state, "view", "publicSectionView")
                ? "publicSectionView"
                : hasVariant($state, "view", "seeAllView")
                ? "seeAllView"
                : undefined
            }
          />
        ) : null}
      </p.Stack>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: [
    "root",
    "headerMenu",
    "signUpButton",
    "shinyButton",
    "buttonDefault",
    "text",
    "freeBox",
    "editButton",
    "editIconRed",
    "editIconBlue",
    "editIcon",
    "svg",
    "smallOverlayMenu"
  ],
  headerMenu: [
    "headerMenu",
    "signUpButton",
    "shinyButton",
    "buttonDefault",
    "text",
    "freeBox",
    "editButton",
    "editIconRed",
    "editIconBlue",
    "editIcon",
    "svg",
    "smallOverlayMenu"
  ],
  signUpButton: ["signUpButton", "shinyButton", "buttonDefault", "text"],
  shinyButton: ["shinyButton"],
  buttonDefault: ["buttonDefault", "text"],
  text: ["text"],
  freeBox: ["freeBox"],
  editButton: ["editButton", "editIconRed", "editIconBlue", "editIcon", "svg"],
  editIconRed: ["editIconRed"],
  editIconBlue: ["editIconBlue"],
  editIcon: ["editIcon"],
  svg: ["svg"],
  smallOverlayMenu: ["smallOverlayMenu"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  headerMenu: "div";
  signUpButton: "div";
  shinyButton: typeof ShinyButton;
  buttonDefault: "div";
  text: "div";
  freeBox: "div";
  editButton: "button";
  editIconRed: typeof EditIconRed;
  editIconBlue: typeof EditIconBlue;
  editIcon: typeof EditIcon;
  svg: "svg";
  smallOverlayMenu: typeof SmallOverlayMenu;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicHeaderMenu__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicHeaderMenu__VariantsArgs;
    args?: PlasmicHeaderMenu__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicHeaderMenu__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    /* Specify args directly as props*/ Omit<
      PlasmicHeaderMenu__ArgsType,
      ReservedPropsType
    > &
    /* Specify overrides for each element directly as props*/ Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    /* Specify props for the root element*/ Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicHeaderMenu__ArgProps,
          internalVariantPropNames: PlasmicHeaderMenu__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicHeaderMenu__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicHeaderMenu";
  } else {
    func.displayName = `PlasmicHeaderMenu.${nodeName}`;
  }
  return func;
}

export const PlasmicHeaderMenu = Object.assign(
  // Top-level PlasmicHeaderMenu renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    headerMenu: makeNodeComponent("headerMenu"),
    signUpButton: makeNodeComponent("signUpButton"),
    shinyButton: makeNodeComponent("shinyButton"),
    buttonDefault: makeNodeComponent("buttonDefault"),
    text: makeNodeComponent("text"),
    freeBox: makeNodeComponent("freeBox"),
    editButton: makeNodeComponent("editButton"),
    editIconRed: makeNodeComponent("editIconRed"),
    editIconBlue: makeNodeComponent("editIconBlue"),
    editIcon: makeNodeComponent("editIcon"),
    svg: makeNodeComponent("svg"),
    smallOverlayMenu: makeNodeComponent("smallOverlayMenu"),

    // Metadata about props expected for PlasmicHeaderMenu
    internalVariantProps: PlasmicHeaderMenu__VariantProps,
    internalArgProps: PlasmicHeaderMenu__ArgProps
  }
);

export default PlasmicHeaderMenu;
/* prettier-ignore-end */
